module.exports = {"id":"200298","name":"Jonathan Rivierez","rating":"71","photo":"./data/images/photos/4/200298.png","club":{"name":"FC Metz","logo":"./data/images/clubs/FCMetz.png"},"positions":["DD","DC","DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JonathanRivierez0.json
// module id = 2106
// module chunks = 0